"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationsMap = getTranslationsMap;
exports.createLocalTranslationsAPIHandler = createLocalTranslationsAPIHandler;
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const enums_1 = require("@finbackoffice/enums");
function getTranslationsMap() {
    const directoryPath = path_1.default.join(process.cwd(), "translations");
    const files = fs_1.default.readdirSync(directoryPath);
    const translations = {};
    for (const file of files) {
        const scope = file.replace(".json", "");
        const json = fs_1.default.readFileSync(path_1.default.join(directoryPath, file), "utf8");
        const content = JSON.parse(json);
        translations[scope] = content;
    }
    return translations;
}
function createLocalTranslationsAPIHandler() {
    const translationsMap = getTranslationsMap();
    if (process.env.NODE_ENV !== "development" && process.env.SKIP_TRANSLATIONS_UPLOAD !== "true") {
        return (_req, res) => res.status(400).send("This endpoint is allowed for development mode only");
    }
    return (req, res) => {
        const { language, scopes } = req.query;
        if (!language || !scopes) {
            return res.status(400).send("Missing language or scopes");
        }
        const response = {};
        const scopes_without_device = scopes
            .split(",")
            .filter((scope) => !["desktop", "mobile"].includes(scope));
        for (const scope of scopes_without_device) {
            response[scope] = translationsMap[scope].reduce((acc, record) => {
                const translation = record.translations.find((t) => t.language === language);
                const fallback_translation = record.translations.find((t) => t.language === enums_1.Language.en);
                acc[record.key] = translation
                    ? translation.default_content
                    : fallback_translation.default_content;
                return acc;
            }, {});
        }
        res.status(200).send(response);
    };
}
//# sourceMappingURL=local.js.map